export const defaultState = () => {
  return {
    common: {
      gSnackbar: {
        message: "",
        type: ""
      },
      gLoading: {
        text: "",
        active: false,
        size: "large"
      }
    },
    messages: [],
  };
};

const state = defaultState();

export default state;
